<template>
    <CompassDatePicker
        :value="activityDateFormated"
        :input="false"
        :formatDateDisplayed="formatDateDisplayed"
        :placement="placement"
        :calendarOptions="calendarOptions"
        datePickerClass="activities-reschedule-datepicker"
        @update:value="handleUpdateValue"
    >
        <slot></slot>
    </CompassDatePicker>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { difference } from 'lodash';

const { mapState: corpMapState } = createNamespacedHelpers('corp');
const { mapGetters: activitiesMapGetters } = createNamespacedHelpers('activitiesStores');
export default {
    props: {
        //Accept date in string format or directly moment object
        value: {
            type: [String, Object],
            required: true,
        },
        placement: {
            type: String,
            default: 'top-start',
        },
    },
    computed: {
        ...corpMapState(['uiLang', 'timeformat']),
        ...activitiesMapGetters({ metas: 'getMetas' }),
        formatDateDisplayed() {
            return this.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        },
        activityDateFormated() {
            return moment(this.value).format('YYYY-MM-DD');
        },
        disableWeekDays() {
            return difference([0, 1, 2, 3, 4, 5, 6], this.metas.working_days);
        },
        calendarOptions() {
            return {
                lang: this.uiLang,
                disableWeekDays: this.disableWeekDays,
            };
        },
    },
    methods: {
        handleUpdateValue(value) {
            const oldDateMoment = moment(this.value)
            const newDateMoment = moment(value)
            if (oldDateMoment.isSame(newDateMoment, 'day')) {
                return;
            }
            this.$emit('update:value', value)
        },
    },

};
</script>

<style lang="scss">
#compass-date-picker-container {
    .activities-reschedule-datepicker {
        z-index: 1000;
    }
}
</style>
